import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  max-width: 1156px;
  position: relative;
  padding: 30px 16px 16px;
  min-height: 80vh;
  margin: 0 auto;
`

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 24px 81px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
`

export const DetailCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 1156px;
  max-width: 100%;
  margin: 0 auto;
  padding: 32px 100px;
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  h1 {
    font-size: 2.4rem;
    line-height: 3rem;
    font-weight: 700;
    color: #2c2c2c;
  }

  .page-subtitle {
    font-size: 1.6rem !important;
    font-weight: 400;
    color: #4d4d4d;
  }
`

export const DoctorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 54px;

  .doctor-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .doctor-name {
    font-size: 2.4rem !important;
    font-weight: 600;
    color: #2c2c2c;
  }

  .doctor-meta {
    font-size: 1.6rem !important;
    font-weight: 600;
    color: #4d4d4d;
  }
`

export const DoctorAvatar = styled.div<{ hasPhoto: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ hasPhoto }) => (hasPhoto ? 'transparent' : '#ff5100')};
  color: #efefef;
  font-size: 1.4rem;
  font-weight: 700;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const TabsList = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  border-bottom: 1px solid #f0f0f0;
  overflow-x: auto;
`

export const TabButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.4rem !important;
  font-weight: 600;
  color: #4d4d4d;
  white-space: nowrap;
  border-bottom: 2px solid transparent;

  svg {
    width: 14px;
    height: 14px;
  }

  &.active {
    color: #ff5100;
    border-bottom-color: #ff5100;
  }
`

export const TabContent = styled.div`
  padding: 24px 0 0;
`

export const SummaryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
`

export const SectionTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
  margin: 0;
`

export const PeriodSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.black};
    min-width: 90px;
    text-align: center;
    text-transform: capitalize;
  }
`

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-top: 20px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const SummaryMetricCard = styled.div<{ span?: number }>`
  grid-column: span ${({ span = 3 }) => span};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #f0f0f0;

  @media (max-width: 960px) {
    grid-column: span 1;
  }

  .icon-wrapper {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: #fff1e0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      font-size: 2.2rem;
      color: #ff5100;
    }

    img {
      width: 22px;
      height: 22px;
      filter: brightness(0) saturate(100%) invert(34%) sepia(90%)
        saturate(1500%) hue-rotate(2deg) brightness(1.1);
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .label {
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.gray80};
    font-weight: 400;
  }

  .value {
    font-size: 1.8rem !important;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black};
    text-transform: capitalize;
  }
`
